const VALUES = [
  { title: "Registered NDIS provider", text: "A provider you can trust — meeting NDIS quality and safeguard standards across every support we deliver." },
  { title: "A local team that shows up", text: "South Australian support workers and coordinators who genuinely care, arrive on time, and know your community." },
  { title: "Personal attention, always", text: "We stay small on purpose. You deal directly with the people who support you — never a call centre." },
];

export default function About() {
  return (
    <section id="why-us" className="py-20 px-5 sm:px-8 bg-[#FAF8F5] border-t border-[#EAE3D8]" data-testid="about-section">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5 space-y-6">
          <span className="text-xs uppercase tracking-widest text-[#786655] font-semibold">Why Beneficence</span>
          <h2 className="text-3xl sm:text-4xl font-display font-medium text-[#1E282D]">A small South Australian team, by design</h2>
          <p className="text-base text-[#4E5B62] leading-relaxed">
            Beneficence Care is a registered NDIS provider supporting participants, coordinators and families across South Australia. Our team has spent years supporting SA families — and we keep our caseload personal so every client is known by name.
          </p>
          <p className="text-base text-[#4E5B62] leading-relaxed">
            We welcome plan-managed, self-managed and NDIA-managed participants, and work directly with support coordinators on referrals statewide.
          </p>
        </div>
        <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-3 gap-6 content-start">
          {VALUES.map((v, i) => (
            <div key={v.title} className="p-6 rounded-2xl bg-[#F6F1EA] border border-[#E7E0D3] space-y-3 reveal" style={{ animationDelay: `${i * 0.08}s` }}>
              <div className="text-xs font-semibold uppercase tracking-wider text-[#6F5F50]">{String(i + 1).padStart(2, "0")}</div>
              <h3 className="text-lg font-display font-medium text-[#1E282D]">{v.title}</h3>
              <p className="text-sm text-[#4F5C63] leading-relaxed">{v.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
